export const footerLinks = {
    'ca-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://ca.wingie.com/de/flug/nach-toronto/',
                    title: 'Toronto',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/nach-vancouver/',
                    title: 'Vancouver',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/nach-montreal/',
                    title: 'Montreal',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/nach-calgary/',
                    title: 'Calgary',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/nach-ottawa/',
                    title: 'Ottawa',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/nach-edmonton/',
                    title: 'Edmonton',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://ca.wingie.com/de/flug/us-vereinigte-staaten-von-amerika/',
                    title: 'Vereinigte Staaten',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/mx-mexiko/',
                    title: 'Mexiko',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/gb-vereinigtes-konigreich/',
                    title: 'Großbritannien',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/fr-frankreich/',
                    title: 'Frankreich',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/in-indien/',
                    title: 'Indien',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://ca.wingie.com/de/flug/airlines/air-canada/',
                    title: 'Air Canada',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/airlines/westjet/',
                    title: 'WestJet',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/airlines/air-transat/',
                    title: 'Air Transat',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/airlines/porter-airlines/',
                    title: 'Porter Airlines',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/airlines/flair-airlines/',
                    title: 'Flair Airlines',
                },
                {
                    href: 'https://ca.wingie.com/de/flug/airlines/sunwing-airlines/',
                    title: 'Sunwing Airlines',
                },
            ],
        },
    ],
    'ca-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    title: 'Toronto',
                    href: 'https://ca.wingie.com/flights/to-toronto/',
                },
                {
                    title: 'Vancouver',
                    href: 'https://ca.wingie.com/flights/to-vancouver/',
                },
                {
                    title: 'Montreal',
                    href: 'https://ca.wingie.com/flights/to-montreal/',
                },
                {
                    title: 'Calgary',
                    href: 'https://ca.wingie.com/flights/to-calgary/',
                },
                {
                    title: 'Ottawa',
                    href: 'https://ca.wingie.com/flights/to-ottawa/',
                },
                {
                    title: 'Edmonton',
                    href: 'https://ca.wingie.com/flights/to-edmonton/',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    title: 'United States',
                    href: 'https://ca.wingie.com/flights/us-united-states-of-america/',
                },
                {
                    title: 'Mexico',
                    href: 'https://ca.wingie.com/flights/mx-mexico/',
                },
                {
                    title: 'United Kingdom',
                    href: 'https://ca.wingie.com/flights/gb-united-kingdom/',
                },
                {
                    title: 'France',
                    href: 'https://ca.wingie.com/flights/fr-france/',
                },
                {
                    title: 'Germany',
                    href: 'https://ca.wingie.com/flights/de-germany/',
                },
                {
                    title: 'Italy',
                    href: 'https://ca.wingie.com/flights/it-italy/',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    title: 'Air Canada',
                    href: 'https://ca.wingie.com/flights/airlines/air-canada/',
                },
                {
                    title: 'WestJet',
                    href: 'https://ca.wingie.com/flights/airlines/westjet/',
                },
                {
                    title: 'Air Transat',
                    href: 'https://ca.wingie.com/flights/airlines/air-transat/',
                },
                {
                    title: 'Porter Airlines',
                    href: 'https://ca.wingie.com/flights/airlines/porter-airlines/',
                },
                {
                    title: 'Flair Airlines',
                    href: 'https://ca.wingie.com/flights/airlines/flair-airlines/',
                },
                {
                    title: 'Sunwing Airlines',
                    href: 'https://ca.wingie.com/flights/airlines/sunwing-airlines/',
                },
            ],
        },
    ],
    'ca-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    title: 'Toronto',
                    href: 'https://ca.wingie.com/es/vuelos/a-toronto/',
                },
                {
                    title: 'Vancouver',
                    href: 'https://ca.wingie.com/es/vuelos/a-vancouver/',
                },
                {
                    title: 'Montreal',
                    href: 'https://ca.wingie.com/es/vuelos/a-montreal/',
                },
                {
                    title: 'Calgary',
                    href: 'https://ca.wingie.com/es/vuelos/a-calgary/',
                },
                {
                    title: 'Ottawa',
                    href: 'https://ca.wingie.com/es/vuelos/a-ottawa/',
                },
                {
                    title: 'Edmonton',
                    href: 'https://ca.wingie.com/es/vuelos/a-edmonton/',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    title: 'Estados Unidos',
                    href: 'https://ca.wingie.com/es/vuelos/us-united-states-of-america/',
                },
                {
                    title: 'México',
                    href: 'https://ca.wingie.com/es/vuelos/mx-mexico/',
                },
                {
                    title: 'Reino Unido',
                    href: 'https://ca.wingie.com/es/vuelos/gb-reino-unido/',
                },
                {
                    title: 'Francia',
                    href: 'https://ca.wingie.com/es/vuelos/fr-france/',
                },
                {
                    title: 'Alemania',
                    href: 'https://ca.wingie.com/es/vuelos/de-germany/',
                },
                {
                    title: 'Italia',
                    href: 'https://ca.wingie.com/es/vuelos/it-italy/',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    title: 'Air Canada',
                    href: 'https://ca.wingie.com/es/vuelos/companias-aereas/air-canada/',
                },
                {
                    title: 'WestJet',
                    href: 'https://ca.wingie.com/es/vuelos/companias-aereas/westjet/',
                },
                {
                    title: 'Air Transat',
                    href: 'https://ca.wingie.com/es/vuelos/companias-aereas/air-transat/',
                },
                {
                    title: 'Porter Airlines',
                    href: 'https://ca.wingie.com/es/vuelos/companias-aereas/porter-airlines/',
                },
                {
                    title: 'Flair Airlines',
                    href: 'https://ca.wingie.com/es/vuelos/companias-aereas/flair-airlines/',
                },
                {
                    title: 'Sunwing Airlines',
                    href: 'https://ca.wingie.com/es/vuelos/companias-aereas/sunwing-airlines/',
                },
            ],
        },
    ],
    'ca-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://ca.wingie.com/ru/flights/to-toronto/',
                    title: 'Торонто',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/to-vancouver/',
                    title: 'Ванкувер',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/to-montreal/',
                    title: 'Монреаль',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/to-calgary/',
                    title: 'Калгари',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/to-ottawa/',
                    title: 'Оттава',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/to-edmonton/',
                    title: 'Эдмонтон',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://ca.wingie.com/ru/flights/us-united-states-of-america/',
                    title: 'США',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/mx-mexico/',
                    title: 'Мексика',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/gb-united-kingdom/',
                    title: 'Великобритания',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/fr-france/',
                    title: 'Франция',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/de-germany/',
                    title: 'Германия',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/it-italy/',
                    title: 'Италия',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://ca.wingie.com/ru/flights/airlines/air-canada/',
                    title: 'Air Canada',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/airlines/westjet/',
                    title: 'WestJet',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/airlines/air-transat/',
                    title: 'Air Transat',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/airlines/porter-airlines/',
                    title: 'Porter Airlines',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/airlines/flair-airlines/',
                    title: 'Flair Airlines',
                },
                {
                    href: 'https://ca.wingie.com/ru/flights/airlines/sunwing-airlines/',
                    title: 'Sunwing Airlines',
                },
            ],
        },
    ],
    'ca-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://ca.wingie.com/ar/flights/to-toronto/',
                    title: 'تورونتو',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/to-vancouver/',
                    title: 'فانكوفر',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/to-montreal/',
                    title: 'مونتريال',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/to-calgary/',
                    title: 'كالغاري',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/to-ottawa/',
                    title: 'أوتاوا',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/to-edmonton/',
                    title: 'إدمونتون',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://ca.wingie.com/ar/flights/us-united-states-of-america/',
                    title: 'الولايات المتحدة',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/mx-mexico/',
                    title: 'المكسيك',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/gb-united-kingdom/',
                    title: 'المملكة المتحدة',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/fr-france/',
                    title: 'فرنسا',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/de-germany/',
                    title: 'ألمانيا',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/it-italy/',
                    title: 'إيطاليا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://ca.wingie.com/ar/flights/airlines/air-canada/',
                    title: 'الخطوط الجوية الكندية',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/airlines/westjet/',
                    title: 'ويستجيت',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/airlines/air-transat/',
                    title: 'إير ترانسات',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/airlines/porter-airlines/',
                    title: 'بورتر إيرلاينز',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/airlines/flair-airlines/',
                    title: 'فلير إيرلاينز',
                },
                {
                    href: 'https://ca.wingie.com/ar/flights/airlines/sunwing-airlines/',
                    title: 'صنوينغ إيرلاينز',
                },
            ],
        },
    ],
    'ca-it': [
        {
            title: 'Destinazioni Top',
            items: [
                { title: 'Toronto', href: 'https://ca.wingie.com/it/flights/to-toronto/' },
                { title: 'Vancouver', href: 'https://ca.wingie.com/it/flights/to-vancouver/' },
                { title: 'Montreal', href: 'https://ca.wingie.com/it/flights/to-montreal/' },
                { title: 'Calgary', href: 'https://ca.wingie.com/it/flights/to-calgary/' },
                { title: 'Ottawa', href: 'https://ca.wingie.com/it/flights/to-ottawa/' },
                { title: 'Edmonton', href: 'https://ca.wingie.com/it/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                { title: 'Stati Uniti', href: 'https://ca.wingie.com/it/flights/us-stati-uniti/' },
                { title: 'Messico', href: 'https://ca.wingie.com/it/flights/mx-messico/' },
                { title: 'Regno Unito', href: 'https://ca.wingie.com/it/flights/gb-regno-unito/' },
                { title: 'Francia', href: 'https://ca.wingie.com/it/flights/fr-francia/' },
                { title: 'Germania', href: 'https://ca.wingie.com/it/flights/de-germania/' },
                { title: 'Italia', href: 'https://ca.wingie.com/it/flights/it-italia/' },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/it/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/it/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/it/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/it/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/it/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/it/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-fr': [
        {
            title: 'Destinations Populaires',
            items: [
                { title: 'Toronto', href: 'https://ca.wingie.com/fr/flights/to-toronto/' },
                { title: 'Vancouver', href: 'https://ca.wingie.com/fr/flights/to-vancouver/' },
                { title: 'Montréal', href: 'https://ca.wingie.com/fr/flights/to-montreal/' },
                { title: 'Calgary', href: 'https://ca.wingie.com/fr/flights/to-calgary/' },
                { title: 'Ottawa', href: 'https://ca.wingie.com/fr/flights/to-ottawa/' },
                { title: 'Edmonton', href: 'https://ca.wingie.com/fr/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                { title: 'États-Unis', href: 'https://ca.wingie.com/fr/flights/us-etats-unis/' },
                { title: 'Mexique', href: 'https://ca.wingie.com/fr/flights/mx-mexique/' },
                { title: 'Royaume-Uni', href: 'https://ca.wingie.com/fr/flights/gb-royaume-uni/' },
                { title: 'France', href: 'https://ca.wingie.com/fr/flights/fr-france/' },
                { title: 'Allemagne', href: 'https://ca.wingie.com/fr/flights/de-allemagne/' },
                { title: 'Italie', href: 'https://ca.wingie.com/fr/flights/it-italie/' },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/fr/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/fr/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/fr/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/fr/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/fr/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/fr/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-pt': [
        {
            title: 'Destinos Populares',
            items: [
                { title: 'Toronto', href: 'https://ca.wingie.com/pt/flights/to-toronto/' },
                { title: 'Vancouver', href: 'https://ca.wingie.com/pt/flights/to-vancouver/' },
                { title: 'Montreal', href: 'https://ca.wingie.com/pt/flights/to-montreal/' },
                { title: 'Calgary', href: 'https://ca.wingie.com/pt/flights/to-calgary/' },
                { title: 'Ottawa', href: 'https://ca.wingie.com/pt/flights/to-ottawa/' },
                { title: 'Edmonton', href: 'https://ca.wingie.com/pt/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                { title: 'Estados Unidos', href: 'https://ca.wingie.com/pt/flights/us-estados-unidos/' },
                { title: 'México', href: 'https://ca.wingie.com/pt/flights/mx-mexico/' },
                { title: 'Reino Unido', href: 'https://ca.wingie.com/pt/flights/gb-reino-unido/' },
                { title: 'França', href: 'https://ca.wingie.com/pt/flights/fr-franca/' },
                { title: 'Alemanha', href: 'https://ca.wingie.com/pt/flights/de-alemanha/' },
                { title: 'Itália', href: 'https://ca.wingie.com/pt/flights/it-italia/' },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/pt/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/pt/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/pt/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/pt/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/pt/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/pt/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-ro': [
        {
            title: 'Destinații Populare',
            items: [
                { title: 'Toronto', href: 'https://ca.wingie.com/ro/flights/to-toronto/' },
                { title: 'Vancouver', href: 'https://ca.wingie.com/ro/flights/to-vancouver/' },
                { title: 'Montreal', href: 'https://ca.wingie.com/ro/flights/to-montreal/' },
                { title: 'Calgary', href: 'https://ca.wingie.com/ro/flights/to-calgary/' },
                { title: 'Ottawa', href: 'https://ca.wingie.com/ro/flights/to-ottawa/' },
                { title: 'Edmonton', href: 'https://ca.wingie.com/ro/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                { title: 'Statele Unite', href: 'https://ca.wingie.com/ro/flights/us-statele-unite-ale-americii/' },
                { title: 'Mexic', href: 'https://ca.wingie.com/ro/flights/mx-mexic/' },
                { title: 'Regatul Unit', href: 'https://ca.wingie.com/ro/flights/gb-regatul-unit/' },
                { title: 'Franța', href: 'https://ca.wingie.com/ro/flights/fr-franta/' },
                { title: 'Germania', href: 'https://ca.wingie.com/ro/flights/de-germania/' },
                { title: 'Italia', href: 'https://ca.wingie.com/ro/flights/it-italia/' },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/ro/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/ro/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/ro/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/ro/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/ro/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/ro/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-pl': [
        {
            title: 'Popularne Destynacje',
            items: [
                { title: 'Toronto', href: 'https://ca.wingie.com/pl/flights/to-toronto/' },
                { title: 'Vancouver', href: 'https://ca.wingie.com/pl/flights/to-vancouver/' },
                { title: 'Montreal', href: 'https://ca.wingie.com/pl/flights/to-montreal/' },
                { title: 'Calgary', href: 'https://ca.wingie.com/pl/flights/to-calgary/' },
                { title: 'Ottawa', href: 'https://ca.wingie.com/pl/flights/to-ottawa/' },
                { title: 'Edmonton', href: 'https://ca.wingie.com/pl/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                { title: 'Stany Zjednoczone', href: 'https://ca.wingie.com/pl/flights/us-stany-zjednoczone/' },
                { title: 'Meksyk', href: 'https://ca.wingie.com/pl/flights/mx-meksyk/' },
                { title: 'Wielka Brytania', href: 'https://ca.wingie.com/pl/flights/gb-wielka-brytania/' },
                { title: 'Francja', href: 'https://ca.wingie.com/pl/flights/fr-francja/' },
                { title: 'Niemcy', href: 'https://ca.wingie.com/pl/flights/de-niemcy/' },
                { title: 'Włochy', href: 'https://ca.wingie.com/pl/flights/it-wlochy/' },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/pl/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/pl/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/pl/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/pl/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/pl/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/pl/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-lt': [
        {
            title: 'Populiarūs Kryptys',
            items: [
                { title: 'Torontas', href: 'https://ca.wingie.com/lt/flights/to-toronto/' },
                { title: 'Vankuveris', href: 'https://ca.wingie.com/lt/flights/to-vancouver/' },
                { title: 'Monrealis', href: 'https://ca.wingie.com/lt/flights/to-montreal/' },
                { title: 'Kalgarys', href: 'https://ca.wingie.com/lt/flights/to-calgary/' },
                { title: 'Otava', href: 'https://ca.wingie.com/lt/flights/to-ottawa/' },
                { title: 'Edmontonas', href: 'https://ca.wingie.com/lt/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                { title: 'Jungtinės Valstijos', href: 'https://ca.wingie.com/lt/flights/us-jungtines-amerikos-valstijos/' },
                { title: 'Meksika', href: 'https://ca.wingie.com/lt/flights/mx-meksika/' },
                { title: 'Jungtinė Karalystė', href: 'https://ca.wingie.com/lt/flights/gb-jungtine-karalyste/' },
                { title: 'Prancūzija', href: 'https://ca.wingie.com/lt/flights/fr-prancuzija/' },
                { title: 'Vokietija', href: 'https://ca.wingie.com/lt/flights/de-vokietija/' },
                { title: 'Italija', href: 'https://ca.wingie.com/lt/flights/it-italija/' },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/lt/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/lt/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/lt/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/lt/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/lt/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/lt/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-uz': [
        {
            title: "Mashhur Yo'nalishlar",
            items: [
                { title: 'Toronto', href: 'https://ca.wingie.com/uz/flights/to-toronto/' },
                { title: 'Vankuver', href: 'https://ca.wingie.com/uz/flights/to-vancouver/' },
                { title: 'Montreal', href: 'https://ca.wingie.com/uz/flights/to-montreal/' },
                { title: 'Kalgari', href: 'https://ca.wingie.com/uz/flights/to-calgary/' },
                { title: 'Ottava', href: 'https://ca.wingie.com/uz/flights/to-ottawa/' },
                { title: 'Edmonton', href: 'https://ca.wingie.com/uz/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                { title: "Amerika Qo'shma Shtatlari", href: 'https://ca.wingie.com/uz/flights/us-united-states-of-america/' },
                { title: 'Meksika', href: 'https://ca.wingie.com/uz/flights/mx-meksika/' },
                { title: 'Buyuk Britaniya', href: 'https://ca.wingie.com/uz/flights/gb-buyuk-britaniya/' },
                { title: 'Fransiya', href: 'https://ca.wingie.com/uz/flights/fr-fransiya/' },
                { title: 'Germaniya', href: 'https://ca.wingie.com/uz/flights/de-germaniya/' },
                { title: 'Italiya', href: 'https://ca.wingie.com/uz/flights/it-italiya/' },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/uz/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/uz/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/uz/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/uz/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/uz/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/uz/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-sr': [
        {
            title: 'Popularne Destinacije',
            items: [
                { title: 'Toronto', href: 'https://ca.wingie.com/sr/flights/to-toronto/' },
                { title: 'Vankuver', href: 'https://ca.wingie.com/sr/flights/to-vancouver/' },
                { title: 'Montreal', href: 'https://ca.wingie.com/sr/flights/to-montreal/' },
                { title: 'Kalgari', href: 'https://ca.wingie.com/sr/flights/to-calgary/' },
                { title: 'Otava', href: 'https://ca.wingie.com/sr/flights/to-ottawa/' },
                { title: 'Edmonton', href: 'https://ca.wingie.com/sr/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Popularne Zemlje',
            items: [
                { title: 'Sjedinjene Američke Države', href: 'https://ca.wingie.com/sr/flights/us-etats-unis/' },
                { title: 'Meksiko', href: 'https://ca.wingie.com/sr/flights/mx-meksiko/' },
                { title: 'Velika Britanija', href: 'https://ca.wingie.com/sr/flights/gb-ujedinjeno-kraljevstvo/' },
                { title: 'Francuska', href: 'https://ca.wingie.com/sr/flights/fr-francuska/' },
                { title: 'Nemačka', href: 'https://ca.wingie.com/sr/flights/de-nemacka/' },
                { title: 'Italija', href: 'https://ca.wingie.com/sr/flights/it-italija/' },
            ],
        },
        {
            title: 'Popularne Avio-kompanije',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/sr/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/sr/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/sr/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/sr/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/sr/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/sr/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-ky': [
        {
            title: 'Популярдуу Багыттар',
            items: [
                { title: 'Торонто', href: 'https://ca.wingie.com/ky/flights/to-toronto/' },
                { title: 'Ванкувер', href: 'https://ca.wingie.com/ky/flights/to-vancouver/' },
                { title: 'Монреаль', href: 'https://ca.wingie.com/ky/flights/to-montreal/' },
                { title: 'Калгари', href: 'https://ca.wingie.com/ky/flights/to-calgary/' },
                { title: 'Оттава', href: 'https://ca.wingie.com/ky/flights/to-ottawa/' },
                { title: 'Эдмонтон', href: 'https://ca.wingie.com/ky/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Популярдуу Өлкөлөр',
            items: [
                { title: 'АКШ', href: 'https://ca.wingie.com/ky/flights/us-amerika-koshmo-shtattary/' },
                { title: 'Мексика', href: 'https://ca.wingie.com/ky/flights/mx-mexico/' },
                { title: 'Улуу Британия', href: 'https://ca.wingie.com/ky/flights/gb-united-kingdom/' },
                { title: 'Франция', href: 'https://ca.wingie.com/ky/flights/fr-france/' },
                { title: 'Германия', href: 'https://ca.wingie.com/ky/flights/de-germany/' },
                { title: 'Италия', href: 'https://ca.wingie.com/ky/flights/it-italy/' },
            ],
        },
        {
            title: 'Популярдуу Авиакомпаниялар',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/ky/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/ky/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/ky/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/ky/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/ky/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/ky/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-tg': [
        {
            title: 'Масҳуртарин Самтҳо',
            items: [
                { title: 'Торонто', href: 'https://ca.wingie.com/tg/flights/to-toronto/' },
                { title: 'Ванкувер', href: 'https://ca.wingie.com/tg/flights/to-vancouver/' },
                { title: 'Монреал', href: 'https://ca.wingie.com/tg/flights/to-montreal/' },
                { title: 'Калгари', href: 'https://ca.wingie.com/tg/flights/to-calgary/' },
                { title: 'Оттава', href: 'https://ca.wingie.com/tg/flights/to-ottawa/' },
                { title: 'Эдмонтон', href: 'https://ca.wingie.com/tg/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Масҳуртарин Кишварҳо',
            items: [
                { title: 'ИМА', href: 'https://ca.wingie.com/tg/flights/us-iyoloti-muttahidai-amriko/' },
                { title: 'Мексика', href: 'https://ca.wingie.com/tg/flights/mx-meksika/' },
                { title: 'Британияи Кабир', href: 'https://ca.wingie.com/tg/flights/gb-britaniyai-kabir/' },
                { title: 'Фаронса', href: 'https://ca.wingie.com/tg/flights/fr-faronsa/' },
                { title: 'Олмон', href: 'https://ca.wingie.com/tg/flights/de-olmon/' },
                { title: 'Италия', href: 'https://ca.wingie.com/tg/flights/it-italiya/' },
            ],
        },
        {
            title: 'Масҳуртарин Авиакомпанияҳо',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/tg/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/tg/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/tg/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/tg/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/tg/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/tg/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-kk': [
        {
            title: 'Танымал Бағыттар',
            items: [
                { title: 'Торонто', href: 'https://ca.wingie.com/kk/flights/to-toronto/' },
                { title: 'Ванкувер', href: 'https://ca.wingie.com/kk/flights/to-vancouver/' },
                { title: 'Монреаль', href: 'https://ca.wingie.com/kk/flights/to-montreal/' },
                { title: 'Калгари', href: 'https://ca.wingie.com/kk/flights/to-calgary/' },
                { title: 'Оттава', href: 'https://ca.wingie.com/kk/flights/to-ottawa/' },
                { title: 'Эдмонтон', href: 'https://ca.wingie.com/kk/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Танымал Елдер',
            items: [
                { title: 'АҚШ', href: 'https://ca.wingie.com/kk/flights/us-amerika-qosalgan-shtattary/' },
                { title: 'Мексика', href: 'https://ca.wingie.com/kk/flights/mx-meksika/' },
                { title: 'Ұлыбритания', href: 'https://ca.wingie.com/kk/flights/gb-ulybrilaniya/' },
                { title: 'Франция', href: 'https://ca.wingie.com/kk/flights/fr-frantsiya/' },
                { title: 'Германия', href: 'https://ca.wingie.com/kk/flights/de-germaniya/' },
                { title: 'Италия', href: 'https://ca.wingie.com/kk/flights/it-italiya/' },
            ],
        },
        {
            title: 'Танымал Авиакомпаниялар',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/kk/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/kk/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/kk/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/kk/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/kk/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/kk/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-nl': [
        {
            title: 'Populaire Bestemmingen',
            items: [
                { title: 'Toronto', href: 'https://ca.wingie.com/nl/flights/to-toronto/' },
                { title: 'Vancouver', href: 'https://ca.wingie.com/nl/flights/to-vancouver/' },
                { title: 'Montreal', href: 'https://ca.wingie.com/nl/flights/to-montreal/' },
                { title: 'Calgary', href: 'https://ca.wingie.com/nl/flights/to-calgary/' },
                { title: 'Ottawa', href: 'https://ca.wingie.com/nl/flights/to-ottawa/' },
                { title: 'Edmonton', href: 'https://ca.wingie.com/nl/flights/to-edmonton/' },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                { title: 'Verenigde Staten', href: 'https://ca.wingie.com/nl/flights/us-verenigde-staten/' },
                { title: 'Mexico', href: 'https://ca.wingie.com/nl/flights/mx-mexico/' },
                { title: 'Verenigd Koninkrijk', href: 'https://ca.wingie.com/nl/flights/gb-verenigd-koninkrijk/' },
                { title: 'Frankrijk', href: 'https://ca.wingie.com/nl/flights/fr-frankrijk/' },
                { title: 'Duitsland', href: 'https://ca.wingie.com/nl/flights/de-duitsland/' },
                { title: 'Italië', href: 'https://ca.wingie.com/nl/flights/it-italie/' },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                { title: 'Air Canada', href: 'https://ca.wingie.com/nl/flights/airlines/air-canada/' },
                { title: 'WestJet', href: 'https://ca.wingie.com/nl/flights/airlines/westjet/' },
                { title: 'Air Transat', href: 'https://ca.wingie.com/nl/flights/airlines/air-transat/' },
                { title: 'Porter Airlines', href: 'https://ca.wingie.com/nl/flights/airlines/porter-airlines/' },
                { title: 'Flair Airlines', href: 'https://ca.wingie.com/nl/flights/airlines/flair-airlines/' },
                { title: 'Sunwing Airlines', href: 'https://ca.wingie.com/nl/flights/airlines/sunwing-airlines/' },
            ],
        },
    ],
    'ca-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://ca.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://ca.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://ca.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://ca.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://ca.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://ca.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://ca.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://ca.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://ca.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://ca.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://ca.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://ca.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://ca.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://ca.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://ca.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://ca.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ca.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://ca.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ca-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://ca.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://ca.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://ca.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://ca.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://ca.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://ca.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://ca.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://ca.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://ca.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://ca.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://ca.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://ca.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://ca.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://ca.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://ca.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://ca.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ca.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://ca.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ca-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://ca.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://ca.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://ca.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://ca.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://ca.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://ca.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://ca.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://ca.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://ca.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://ca.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://ca.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://ca.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://ca.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://ca.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://ca.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://ca.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ca.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://ca.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ca-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://ca.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://ca.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://ca.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://ca.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://ca.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://ca.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://ca.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://ca.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://ca.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://ca.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://ca.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://ca.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://ca.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://ca.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://ca.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://ca.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ca.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://ca.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ca-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://ca.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://ca.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://ca.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://ca.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://ca.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://ca.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://ca.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://ca.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://ca.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://ca.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://ca.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://ca.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://ca.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://ca.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://ca.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://ca.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ca.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://ca.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ca-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://ca.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://ca.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://ca.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://ca.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://ca.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://ca.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://ca.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://ca.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://ca.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://ca.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://ca.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://ca.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://ca.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://ca.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://ca.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://ca.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ca.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://ca.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ca-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://ca.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://ca.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://ca.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://ca.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://ca.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://ca.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://ca.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://ca.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://ca.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://ca.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://ca.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://ca.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://ca.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://ca.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://ca.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://ca.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ca.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://ca.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ca-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://ca.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://ca.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://ca.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://ca.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://ca.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://ca.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://ca.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://ca.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://ca.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://ca.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://ca.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://ca.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://ca.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://ca.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://ca.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://ca.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ca.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://ca.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}